import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
// import * as $ from 'jquery';
import {
  faConnectdevelop,
  faGgCircle,
} from '@fortawesome/free-brands-svg-icons';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { SharedService } from '../shared/services/shared.service';
import { AppService } from '../shared/services/app.service';
import { CookieService } from 'ngx-cookie-service';
import { UserManagementService } from '../shared/services/user-management.service';
import { Pipe, PipeTransform } from '@angular/core';
import {
  faArrowAltCircleRight,
  faCheckCircle,
  faCircle,
  faMinus,
  faPlus,
  faSpinner,

} from '@fortawesome/free-solid-svg-icons';
import {
  faDotCircle,
} from '@fortawesome/free-regular-svg-icons';
declare var $: any;
import { Config } from '../config';
import { TaskPlannerComponent } from '../task-planner/task-planner.component';
import { MainComponent } from '../main/main.component';
import { ChecklistComponent } from '../checklist/checklist.component';
import { DeepDiveComponent } from '../deep-dive/deep-dive.component';
import { TestDesignerComponent } from '../test-designer/test-designer.component';
import { TestExecutorComponent } from '../test-executor/test-executor.component';
import { SocketService } from '../shared/services/socket.service';
import { Subscription } from 'rxjs';
import { ReloadToolService } from '../shared/services/reload-tool.service';
import { InteractionMapperMindMapComponent } from '../interaction-mapper-mind-map/interaction-mapper-mind-map.component';
// import { PersonaMapperEntityMindMapComponent } from '../persona-mapper-entity-mind-map/persona-mapper-entity-mind-map.component';
// import { TestManagerComponent } from '../test-manager/test-manager.component';

@Component({
  selector: 'app-planner',
  templateUrl: './planner.component.html',
  styleUrls: ['./planner.component.scss'],
})
export class PlannerComponent implements OnInit {
  // Icons
  faCircle = faCircle;
  faArrowAltCircleRight = faArrowAltCircleRight;
  faCheckCircle = faCheckCircle;
  faPlus = faPlus;
  faMinus = faMinus;
  faSpinner = faSpinner;
  clickEventsubscriptionSocket: Subscription;
  clickEventsubscriptionPlanListLoad: Subscription;
  sprintTasksSub: Subscription;
  tempsprintNamesCompleteArrayAll: any = [];
  sprintNamesArrayCompleteAll: any = [];
  sprintNamesArrayComplete: any = [];
  userStoriesListCompleteAll: any = [];
  tempSprintNamesCompleteArray: any = [];
  sprintNamesArraySession: any = [];
  sessionModuleNamesArray: any = [];
  sessionModuleNamesArrayAll: any = [];
  moduleTasksListSessionAll: any = [];
  tempprojectNamesArrayAll: any = [];
  projectNamesArrayAll: any = [];
  userStoriesProjectListAll: any = [];
  listForProjectTasks: any = '';
  listForMyTasks: any = '';
  lastActiveProjectAccordId: any;
  lastActiveMyTasksAccordId: any;
  loader: any = true;

  constructor(
    public translate: TranslateService,
    private router: Router,
    private ProjectServices: ProjectServicesService,
    private _sharedService: SharedService,
    private AppService: AppService,
    private socketService: SocketService,
    private reloadToolService: ReloadToolService,
    private cookieService: CookieService,
    private userManagementService: UserManagementService,
    private Config: Config,
    // public taskPlanner: TaskPlannerComponent,
    public mainComponent: MainComponent,
    public checklistComponent: ChecklistComponent,
    public deepDiveComponent: DeepDiveComponent,
    public testDesignerComponent: TestDesignerComponent,
    public testExecutorComponent: TestExecutorComponent,
    public interactionMapperMindMapComponent: InteractionMapperMindMapComponent,
    // public PersonaMapperEntityMindMapComponent: PersonaMapperEntityMindMapComponent
    // public testManagerComponent: TestManagerComponent,
    // public taskPlannerComponent:TaskPlannerComponent
  ) {
    this.clickEventsubscriptionSocket = this.socketService
      .getClickEvent()
      .subscribe(() => {
        this.ngOnInit();
      });

    this.clickEventsubscriptionPlanListLoad = this.reloadToolService
      .getClickEvent()
      .subscribe((tasks) => {
        this.loadMytasksList(tasks);
      });

    this.sprintTasksSub = this.reloadToolService
      .getSprintTasks()
      .subscribe((stasks) => {
        this.loadSprintTasksList(stasks);
        this.loadSprintUserStoryList(stasks);
      });

    this.sprintTasksSub = this.reloadToolService
      .getSmartChecklist()
      .subscribe((tool) => {
        this.openSmartChecklist(tool);
      });

    const browserLang = this.cookieService.get('language');
    translate.use(browserLang.match(/en|jp/) ? browserLang : 'en');
  }
  modelData: any;
  MyTaskPendingstatus: any;
  MyTaskPendingTeststatus: any;
  MyTaskPendingReTeststatus: any;
  readyEUTStatus: any;
  Attributestatus = 0;
  EUTCleanStatus: any;
  EUTCleanTFStatus: any;
  EUTCleanBFStatus: any;
  EUTCleanURStatus: any;
  EUTCleanXXStatus: any;
  AttriCleanStatus: any;
  Scenariostatus: any;
  ScenarioExecutePositivestatus: any;
  ScenarioExecuteNegativestatus: any;
  ScenarioFunctionalstatus: any;
  ScenarioNonFunctionalstatus: any;
  scenarioTFStatus: any;
  scenarioURStatus: any;
  scenarioBFStatus: any;
  scenarioXXStatus: any;
  smartChecklistTrigger = 0;
  cleanAttriOutcome = 0;
  cleanEUTOutcome = 0;
  cleanEUTTFOutcome = 0;
  cleanEUTBFOutcome = 0;
  cleanEUTUROutcome = 0;
  cleanEUTXXOutcome = 0;
  cleanEUTTFTotalOutcome = 0;
  cleanEUTBFTotalOutcome = 0;
  cleanEUTURTotalOutcome = 0;
  cleanEUTXXTotalOutcome = 0;
  EUTEvaluationCount = 0;
  EUTEvaluationStatus = 0;
  AttributeEvaluationCount = 0;
  AttributeEvaluationStatus = 0;
  myTaskCount = 0;
  myTaskTestCount = 0;
  myTaskReTestCount = 0;
  myTaskPendingCount = 0;
  readyEUTCount = 0;
  notReadyEUTCount = 0;
  scenarioAttriCount = 0;
  scenarioExectuCount = 0;
  scenarioEvalFunctional = 0;
  scenarioEvalNonFunctional = 0;
  scenarioEvalFunctionalExe = 0;
  scenarioEvalNonFunctionalExe = 0;
  scenarioExectuPositiveCount = 0;
  scenarioExectuNegativeCount = 0;
  scenarioExecTF = 0;
  scenarioTF = 0;
  scenarioExecUR = 0;
  scenarioUR = 0;
  scenarioExecBF = 0;
  scenarioBF = 0;
  scenarioExecXX = 0;
  scenarioXX = 0;
  scenarioExecTFStatus = 0;
  scenarioExecBFStatus = 0;
  scenarioExecURStatus = 0;
  scenarioExecXXStatus = 0;
  detailsAttributeCount = 0;
  functionalScenarioCount = 0;
  functionalScenarioPostiveCount = 0;
  functionalScenarioNegativeCount = 0;
  nonFunctionalScenarioCount = 0;
  nonFunctionalScenarioPostiveCount = 0;
  nonFunctionalScenarioNegativeCount = 0;
  myTasksList: any;
  planName: any = {};
  planNamesArray: any = [];
  tempPlanNamesArray: any = [];
  planNamesArrayAll: any = [];
  tempPlanNamesArrayAll: any = [];
  readyAttributes: any = [];
  evaluvatedAttributes: any = [];
  evaluvatedEntities: any = [];
  cleanAttributes: any = [];
  cleanEntities: any = [];
  showMoreButtom = '';
  sessionHistoryArray: any = [];
  filter: any = "Pending";
  tasksFilterArray: any = ["Pending", "Completed"];
  activeProjectTab: any;
  activeCockpitTab: any;
  activeSmartChecklist = '';
  userId: any = localStorage.getItem('userID');
  proTabFilter: any = { history: false };
  mytasksTabFilter: any = { assignedto: this.userId, history: false };
  sessionTabFilter: any = {
    status: 2,
    assignedto: this.userId,
    history: false,
  };
  filterTypeCountSession: any = { type: 'session' };
  filterTypeCountProject: any = { type: 'project' };
  filterTypeCountCompleted: any = { type: 'completed' };
  filterTypeCount: any = { type: 'count' };
  filterTypeList: any = { type: 'list' };
  tasks: any = [];
  userName = localStorage.getItem('userName');
  matchedScenario: any;
  euts: any;
  attributes: any;
  scenarios: any;
  runinfo: any;
  cockpit: any;
  matchedRuninfo: any;
  matchedEutinfo: any;
  scenarioTotalTF: any;
  scenarioTotalUR: any;
  scenarioTotalBF: any;
  scenarioTotalXX: any;
  matchedEntity: any;
  matchedscenarioUR: any;
  matchedscenarioXX: any;
  currentTask: any;
  matchedscenarioTF: any;
  clean4: any;
  matchedscenarioBF: any;
  runInfo: any;
  clean3: any;
  clean2: any;
  clean1: any;
  breakScenarios: any;
  breakScenariosloop: any;
  persona: any = [];
  env: any = [];
  sprintTasks: any;
  mySprintTasksList: any = [];
  sprintNamesArray: any = [];
  tempSprintNamesArray: any = [];
  sprintNamesArrayAll: any = [];
  tempsprintNamesArrayAll: any = [];
  userStoriesListAll: any = [];
  taskHistory: any = false;

  ngOnInit(): void {
    this.modelData = this._sharedService.loadedProjectData.model;
    this.shiftCockpitTabs('elements');
    // console.log('modelData in planner', this.modelData.persona);
    this.loadMytasksList(this.modelData.tasks);
    this.persona = this.modelData.persona;
    this.env = this.modelData.listOfEnv;
    this.tasks = this.modelData.tasks;
    this.euts = this.modelData.listOfEUTs;
    this.attributes = this.modelData.listOfAttributes;
    this.scenarios = this.modelData.scenarios;
    this.runinfo = this.modelData.runInfo;
    this.userId = localStorage.getItem('userID');
    this.cockpit = this.modelData.cockpit;
    // this.tasks = this.modelData.tasks;

    // this.loadProjectTasksList(this.tasks);
    // this.loadProjectUserStoryList(this.tasks);

    // this.loadSprintTasksList(this.tasks);
    // this.loadSprintUserStoryList(this.tasks);

    // this.loadSprintTasksCompletedList(this.tasks);
    // this.loadSprintUserStoryCompletedList(this.tasks);

    // this.loadSprintTasksSessionList(this.tasks);
    // this.loadSprintUserStorySessionList(this.tasks);

    this.getHistoryArray();
    setInterval(() => {
      this.updateProjectData();
    }, 2000);
    var activetab = window.localStorage.getItem("activeTaskTab");
    var openedEntity = window.localStorage.getItem("openedEntity");
    if (!activetab) {
      this.shiftProjectTabs('myTasks');
    } else {
      this.shiftProjectTabs(activetab);
      this.setToggleIconSession(openedEntity, true);
    }
  }


  openSmartChecklist(tool: any) {
    this.smartChecklistTrigger++;
    // console.log("toolllll", this.smartChecklistTrigger);
    if (this.smartChecklistTrigger == 1) {
      this.activeSmartChecklist = tool;
    }
    if (this.smartChecklistTrigger == 2) {
      if (this.activeSmartChecklist != '') {
        this.activeSmartChecklist = '';
      }
      this.smartChecklistTrigger = 0;
    }
  }

  resetSmartChecklist() {
    this.activeSmartChecklist = '';
  }
  updateProjectData() {
    if (
      JSON.stringify(this.modelData) != localStorage.getItem('lastUpdatedModel')
    ) {
      this.loadDashboardElements();
    }
    this._sharedService.projectContent(this.modelData);
  }

  shiftProjectTabs(tabname: any) {
    this.activeProjectTab = tabname;
    
    if (tabname == 'sprint') {
      this.mainComponent.activateLoader(true);
      this.projectNamesArrayAll = [];
      this.userStoriesProjectListAll = [];
      this.loadProjectTasksList(this.modelData.tasks);
      this.loadProjectUserStoryList(this.modelData.tasks);
    }
    if (tabname == 'myTasks') {
      this.mainComponent.activateLoader(true);
      this.loadSprintTasksList(this.modelData.tasks);
      this.loadSprintUserStoryList(this.modelData.tasks);

      this.loadSprintTasksCompletedList(this.modelData.tasks);
      this.loadSprintUserStoryCompletedList(this.modelData.tasks);
    }
    if (tabname == 'session') {
      this.mainComponent.activateLoader(true);
      this.loadSprintTasksSessionList(this.modelData.tasks);
      this.loadSprintUserStorySessionList(this.modelData.tasks);
    }
    window.localStorage.setItem("activeTaskTab", this.activeProjectTab);
  }

  shiftCockpitTabs(tabname: any) {
    // console.log(tabname);
    this.activeCockpitTab = tabname;
  };
  updatetasksFilter(filter: any) {
    this.filter = filter;
    if (filter == 'Pending') {
      this.taskHistory = false;
      // this.filterTypeCount = { type: 'count' };
    } else {
      this.taskHistory = true;
      // this.filterTypeCount = { type: 'completed' };
    }

  }

  loadMytasksList(tasks: any) {
    // console.log('loadMytasksList tasks', tasks);
    this.myTasksList = [];
    this.planNamesArray = [];
    this.tempPlanNamesArray = [];
    this.planNamesArrayAll = [];
    this.tempPlanNamesArrayAll = [];
    for (var t: any = 0; t < tasks.length; t++) {
      if (
        tasks[t].assignedto == this.userId &&
        (tasks[t].status == 2 || tasks[t].status == 1)
      ) {
        this.tempPlanNamesArray.push(tasks[t].plan_name);
        this.tempPlanNamesArray = this.getUnique(this.tempPlanNamesArray);
      }
      if (t == tasks.length - 1) {
        for (var p = 0; p < this.tempPlanNamesArray.length; p++) {
          var tempPlan: any = {};
          tempPlan.plan_name = this.tempPlanNamesArray[p];
          tempPlan.planID = this.uuidv4();
          this.planNamesArray.push(tempPlan);
        }
      }
    }
    for (var s = 0; s < tasks.length; s++) {
      if (tasks[s].status == 2 || tasks[s].status == 1) {
        this.tempPlanNamesArrayAll.push(tasks[s].plan_name);
        this.tempPlanNamesArrayAll = this.getUnique(this.tempPlanNamesArrayAll);
      }
      if (s == tasks.length - 1) {
        for (var q = 0; q < this.tempPlanNamesArrayAll.length; q++) {
          var tempPlanAll: any = {};
          tempPlanAll.plan_name = this.tempPlanNamesArrayAll[q];
          tempPlanAll.planID = this.uuidv4();
          this.planNamesArrayAll.push(tempPlanAll);
        }
      }
    }
    // console.log('planNamesArrayAll', this.planNamesArrayAll);
    // console.log('planNamesArray', this.planNamesArray);
  }

  loadProjectTasksList(tasks: any) {
    if (this.projectNamesArrayAll.length == 0) {
      this.tempprojectNamesArrayAll = [];
      this.projectNamesArrayAll = [];
      for (var s = 0; s < tasks.length; s++) {
        if ((tasks[s].assignedto == '' && tasks[s].activity.type != 'RI') && tasks[s].status != 3) {
          // console.log("module", tasks[s].moduleName);
          this.tempprojectNamesArrayAll.push(tasks[s].moduleName);
          this.tempprojectNamesArrayAll = this.getUnique(this.tempprojectNamesArrayAll);
        }
        // console.log('tempprojectNamesArrayAll', this.tempprojectNamesArrayAll);
        if (s == tasks.length - 1) {
          for (var q = 0; q < this.tempprojectNamesArrayAll.length; q++) {
            var tempPlanAll: any = {};
            tempPlanAll.sprintName = this.tempprojectNamesArrayAll[q];
            tempPlanAll.sprintID = this.uuidv4();
            this.projectNamesArrayAll.push(tempPlanAll);
          }
        }
      }
    }
    // console.log("this.projectNamesArrayAll", this.projectNamesArrayAll);
  }

  loadProjectUserStoryList(tasks: any) {
    if (this.userStoriesProjectListAll.length == 0) {
      let tempUesrStories = [];
      this.userStoriesProjectListAll = [];
      for (let i = 0; i < tasks.length; i++) {
        if (tasks[i].assignedto == '' && tasks[i].activity.type != 'RI') {
          tempUesrStories.push(tasks[i]);
          this.userStoriesProjectListAll = this.getUniqueUserStory(tempUesrStories);
        }

      }
    }
    this.mainComponent.activateLoader(false);
    // console.log("this.userStoriesProjectListAll", this.userStoriesProjectListAll);
  }

  loadSprintTasksList(tasks: any) {
    // console.log('this.userId', this.userId);
    // console.log('loadSprintTasksList tasks', tasks);
    this.mySprintTasksList = [];
    this.sprintNamesArray = [];
    this.tempSprintNamesArray = [];
    this.sprintNamesArrayAll = [];
    this.tempsprintNamesArrayAll = [];

    for (var t: any = 0; t < tasks.length; t++) {
      if (this.userId == tasks[t].assignedto && (tasks[t].status == 2 || tasks[t].status == 1)) {
        this.tempSprintNamesArray.push(tasks[t].moduleName);
        this.tempSprintNamesArray = this.getUnique(this.tempSprintNamesArray);
      }
      if (t == tasks.length - 1) {
        for (var p = 0; p < this.tempSprintNamesArray.length; p++) {
          var tempPlan: any = {};
          tempPlan.sprintName = this.tempSprintNamesArray[p];
          tempPlan.sprintID = this.uuidv4();
          this.sprintNamesArray.push(tempPlan);
        }
      }
    }
    for (var s = 0; s < tasks.length; s++) {
      if ((this.userId == tasks[s].assignedto && tasks[s].activity.type != 'RI') && (tasks[s].status == 2 || tasks[s].status == 1)) {
        // console.log("module", tasks[s].moduleName);
        this.tempsprintNamesArrayAll.push(tasks[s].moduleName);
        this.tempsprintNamesArrayAll = this.getUnique(this.tempsprintNamesArrayAll);
      }
      // console.log('tempsprintNamesArrayAll', this.tempsprintNamesArrayAll);
      if (s == tasks.length - 1) {
        for (var q = 0; q < this.tempsprintNamesArrayAll.length; q++) {
          var tempPlanAll: any = {};
          tempPlanAll.sprintName = this.tempsprintNamesArrayAll[q];
          tempPlanAll.sprintID = this.uuidv4();
          this.sprintNamesArrayAll.push(tempPlanAll);
        }
      }
    }
    // console.log('sprintNamesArrayAll', this.sprintNamesArrayAll);
    // console.log('sprintNamesArray', this.sprintNamesArray);
  }

  loadSprintUserStoryList(tasks: any) {
    let tempUesrStories = [];
    this.userStoriesListAll = [];
    for (let i = 0; i < tasks.length; i++) {
      if (this.userId == tasks[i].assignedto && tasks[i].completed == false && tasks[i].activity.type != 'RI') {
        tempUesrStories.push(tasks[i]);
        this.userStoriesListAll = this.getUniqueUserStory(tempUesrStories);
      }

    }
    this.mainComponent.activateLoader(false);
    // console.log("this.userStoriesListAll", this.userStoriesListAll);
  }


  loadSprintTasksCompletedList(tasks: any) {
    // console.log('this.userId', this.userId);
    // console.log('loadSprintTasksList tasks', tasks);
    // this.mySprintTasksList = [];
    // this.sprintNamesArrayComplete = [];
    // this.tempSprintNamesCompleteArray = [];
    // this.sprintNamesArrayAll = [];
    this.tempsprintNamesCompleteArrayAll = [];
    this.sprintNamesArrayCompleteAll = [];

    // for (var t: any = 0; t < tasks.length; t++) {
    //   if (tasks[t].assignedto == this.userId && tasks[t].status == 3) {
    //     this.tempSprintNamesCompleteArray.push(tasks[t].moduleName);
    //     this.tempSprintNamesCompleteArray = this.getUnique(this.tempSprintNamesCompleteArray);
    //   }
    //   if (t == tasks.length - 1) {
    //     for (var p = 0; p < this.tempSprintNamesCompleteArray.length; p++) {
    //       var tempPlan: any = {};
    //       tempPlan.sprintName = this.tempSprintNamesCompleteArray[p];
    //       tempPlan.sprintID = this.uuidv4();
    //       this.sprintNamesArrayComplete.push(tempPlan);
    //     }
    //   }
    // }
    for (var s = 0; s < tasks.length; s++) {
      if (tasks[s].assignedto == this.userId && tasks[s].status == 3) {
        // console.log("module", tasks[s].moduleName);
        this.tempsprintNamesCompleteArrayAll.push(tasks[s].moduleName);
        this.tempsprintNamesCompleteArrayAll = this.getUnique(this.tempsprintNamesCompleteArrayAll);
      }
      // console.log('tempsprintNamesArrayAll', this.tempsprintNamesCompleteArrayAll);
      // if (s == tasks.length) {

      // }
    }
    for (var q = 0; q < this.tempsprintNamesCompleteArrayAll.length; q++) {
      var tempPlanAll: any = {};
      tempPlanAll.sprintName = this.tempsprintNamesCompleteArrayAll[q];
      tempPlanAll.sprintID = this.uuidv4();
      // console.log("tempPlanAll", tempPlanAll);
      this.sprintNamesArrayCompleteAll.push(tempPlanAll);
    }
    // console.log('sprintNamesArrayCompleteAll', this.sprintNamesArrayCompleteAll);
  }

  loadSprintUserStoryCompletedList(tasks: any) {
    let tempUesrStories = [];
    this.userStoriesListCompleteAll = [];
    for (let i = 0; i < tasks.length; i++) {
      if (this.userId == tasks[i].assignedto && tasks[i].status == 3) {
        tempUesrStories.push(tasks[i]);
        this.userStoriesListCompleteAll = this.getUniqueUserStory(tempUesrStories);
      }

    }
    // console.log("this.userStoriesListCompleteAll", this.userStoriesListCompleteAll);
  }


  loadSprintTasksSessionList(tasks: any) {
    // console.log('this.userId', this.userId);
    // console.log('loadSprintTasksList tasks', tasks);

    this.sessionModuleNamesArray = [];
    this.sessionModuleNamesArrayAll = [];

    for (var s = 0; s < tasks.length; s++) {
      if (tasks[s].assignedto == this.userId && tasks[s].status == 2) {
        // console.log("module", tasks[s].moduleName);
        this.sessionModuleNamesArray.push(tasks[s].moduleName);
        this.sessionModuleNamesArray = this.getUnique(this.sessionModuleNamesArray);
      }
      // console.log('sessionModuleNamesArray', this.sessionModuleNamesArray);
      if (s == tasks.length - 1) {
        for (var q = 0; q < this.sessionModuleNamesArray.length; q++) {
          var tempPlanAll: any = {};
          tempPlanAll.sprintName = this.sessionModuleNamesArray[q];
          tempPlanAll.sprintID = this.uuidv4();
          this.sessionModuleNamesArrayAll.push(tempPlanAll);
        }
      }
    }
    // console.log('sessionModuleNamesArrayAll', this.sessionModuleNamesArrayAll);
  }

  loadSprintUserStorySessionList(tasks: any) {
    let tempUesrStories = [];
    this.moduleTasksListSessionAll = [];
    for (let i = 0; i < tasks.length; i++) {
      // console.log("tasks[i].",tasks[i].status);
      if (this.userId == tasks[i].assignedto && tasks[i].status != 1 && tasks[i].status != 3) {
        tempUesrStories.push(tasks[i]);
        this.moduleTasksListSessionAll = this.getUniqueUserStory(tempUesrStories);
      }

    }
    this.mainComponent.activateLoader(false);
    // console.log("this.moduleTasksListSessionAll", this.moduleTasksListSessionAll);
  }

  getTaskDesc(task: any) {
    var type = task.toolType;
    if (task.attribute) {
      var attribute = task.attribute.name;
    } else {
      var attribute: any = '';
    }

    var activity = task.activity.type;
    var description: any;
    if (activity == 'TN' || activity == 'RI' || activity == 'RM') {
      if (type == 'pm') {
        description = "do Persona map";
      } else if (type == 'im') {
        description = "do Interaction map";
      } else if (type == 'sc') {
        description = "do Scope map";
      } else if (type == 'dd') {
        description = "do Deep dive ";
      } else if (type == 'de') {
        description = 'do Design for ' + attribute;
      } else if (type == 'ex') {
        description = 'do Test for ' + attribute;
      }
      if (type == 'ex' && activity == 'RI') {
        description = 'do Retest ' + task.moduleName + ' | ' + task.entity_desc + ' for ' + attribute;
      }
      var primaryEntity = { "eName": "(anonymous)" };
      if (task.baseEntity_Id != "") {
        primaryEntity = this.modelData.listOfBaseEUTs.find((eut: any) => eut.eID == task.baseEntity_Id);
      }
      if (type == 'bex' && activity == 'RM') {
        description = 'do Retest ' + task.moduleName + ' | ' + primaryEntity.eName + ' for ' + attribute;
      }

    } else if (activity == 'FT') {
      return task.task_desc;
    }

    return description;
  }
  getUnique(array: any) {
    var uniqueArray = [];
    // Loop through array values
    if (array) {
      for (var i = 0; i < array.length; i++) {
        if (uniqueArray.indexOf(array[i]) === -1) {
          uniqueArray.push(array[i]);
        }
      }
    }
    return uniqueArray;
  }

  getUniqueUserStory(array: any) {
    var uniqueArray: any = [];
    if (array) {
      for (var i = 0; i < array.length; i++) {
        let USFound = uniqueArray.find((us: any) => us.entity_desc == array[i].entity_desc);
        if (USFound === undefined) {
          const updatedObject = {
            ...array[i],
            userStoryID: this.uuidv4()
          };
          uniqueArray.push(updatedObject)
        }
      }
    }
    return uniqueArray;
  }

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  updateTasksTable() {
    // need to call a function in taskplanner tableCollapseExpand
    // this.taskPlannerComponent.tableCollapseExpand();
  }

  //Mark a task as done and set time taken to do this task
  finishTask(task: any) {
    var completed = task.completed == true ? false : true;
    if (completed) {
      var endTime: any = new Date();
      var timeDifference: Number = Math.abs(task.startTime - endTime) / 1000;
      task.completed = completed;
      // task.endTime = this.calculateEndTime(timeDifference);
      task.endTime = '1:00';
    } else {
      task.completed = completed;
      task.endTime = '0:00';
    }
  }

  calculateEndTime(timeDifferenc: any) {
    return (
      this.formatTimeValue(Math.floor(timeDifferenc / 60) % 60) +
      ':' +
      this.formatTimeValue(Number(timeDifferenc % 60))
    );
  }

  setToggleIcon(tagId: any, status: any, type: any) {
    if (status == true) {
      $("." + tagId + "PlusLabel").removeClass("displayNone");
      $("." + tagId + "PlusLabel").removeClass("displayBlock");
      $("." + tagId + "MinusLabel").removeClass("displayNone");
      $("." + tagId + "MinusLabel").removeClass("displayBlock");
      $("." + tagId + "PlusLabel").addClass("displayNone");
      $("." + tagId + "MinusLabel").addClass("displayBlock");
    } else {
      $("." + tagId + "PlusLabel").removeClass("displayNone");
      $("." + tagId + "PlusLabel").removeClass("displayBlock");
      $("." + tagId + "MinusLabel").removeClass("displayNone");
      $("." + tagId + "MinusLabel").removeClass("displayBlock");
      $("." + tagId + "PlusLabel").addClass("displayBlock");
      $("." + tagId + "MinusLabel").addClass("displayNone");
      if (type == 'EUT') {
        this.lastActiveProjectAccordId = '';
      }
    }
  }
  setToggleIconMytasks(tagId: any, status: any) {
    if (status == true) {
      $("." + tagId + "PlusLabel").removeClass("displayNone");
      $("." + tagId + "PlusLabel").removeClass("displayBlock");
      $("." + tagId + "MinusLabel").removeClass("displayNone");
      $("." + tagId + "MinusLabel").removeClass("displayBlock");
      $("." + tagId + "PlusLabel").addClass("displayNone");
      $("." + tagId + "MinusLabel").addClass("displayBlock");
    } else {
      $("." + tagId + "PlusLabel").removeClass("displayNone");
      $("." + tagId + "PlusLabel").removeClass("displayBlock");
      $("." + tagId + "MinusLabel").removeClass("displayNone");
      $("." + tagId + "MinusLabel").removeClass("displayBlock");
      $("." + tagId + "PlusLabel").addClass("displayBlock");
      $("." + tagId + "MinusLabel").addClass("displayNone");
      // if (type == 'EUT') {
      //   this.lastActiveMyTasksAccordId = '';
      // }
    }
  }
  setToggleIconCompleted(tagId: any, status: any) {
    if (status == true) {
      $("." + tagId + "PlusLabel").removeClass("displayNone");
      $("." + tagId + "PlusLabel").removeClass("displayBlock");
      $("." + tagId + "MinusLabel").removeClass("displayNone");
      $("." + tagId + "MinusLabel").removeClass("displayBlock");
      $("." + tagId + "PlusLabel").addClass("displayNone");
      $("." + tagId + "MinusLabel").addClass("displayBlock");
    } else {
      $("." + tagId + "PlusLabel").removeClass("displayNone");
      $("." + tagId + "PlusLabel").removeClass("displayBlock");
      $("." + tagId + "MinusLabel").removeClass("displayNone");
      $("." + tagId + "MinusLabel").removeClass("displayBlock");
      $("." + tagId + "PlusLabel").addClass("displayBlock");
      $("." + tagId + "MinusLabel").addClass("displayNone");
    }
  }
  setToggleIconMyTasks(tagId: any, status: any) {
    if (status == true) {
      $("." + tagId + "PlusLabel").removeClass("displayNone");
      $("." + tagId + "PlusLabel").removeClass("displayBlock");
      $("." + tagId + "MinusLabel").removeClass("displayNone");
      $("." + tagId + "MinusLabel").removeClass("displayBlock");
      $("." + tagId + "PlusLabel").addClass("displayNone");
      $("." + tagId + "MinusLabel").addClass("displayBlock");
    } else {
      $("." + tagId + "PlusLabel").removeClass("displayNone");
      $("." + tagId + "PlusLabel").removeClass("displayBlock");
      $("." + tagId + "MinusLabel").removeClass("displayNone");
      $("." + tagId + "MinusLabel").removeClass("displayBlock");
      $("." + tagId + "PlusLabel").addClass("displayBlock");
      $("." + tagId + "MinusLabel").addClass("displayNone");
    }
  }

  setToggleIconSession(tagId: any, status: any) {
    // console.log("tagId", tagId, status);
    if (status == true) {
      $("." + tagId + "PlusLabel").removeClass("displayNone");
      $("." + tagId + "PlusLabel").removeClass("displayBlock");
      $("." + tagId + "MinusLabel").removeClass("displayNone");
      $("." + tagId + "MinusLabel").removeClass("displayBlock");
      $("." + tagId + "PlusLabel").addClass("displayNone");
      $("." + tagId + "MinusLabel").addClass("displayBlock");
    } else {
      $("." + tagId + "PlusLabel").removeClass("displayNone");
      $("." + tagId + "PlusLabel").removeClass("displayBlock");
      $("." + tagId + "MinusLabel").removeClass("displayNone");
      $("." + tagId + "MinusLabel").removeClass("displayBlock");
      $("." + tagId + "PlusLabel").addClass("displayBlock");
      $("." + tagId + "MinusLabel").addClass("displayNone");
    }
    window.localStorage.setItem("openedEntity", tagId);
  }

  formatTimeValue(value: any) {
    // console.log('formatTimeValue', value);

    if (typeof value === 'number' && value >= 0) {
      return (value < 10 ? '0' : '') + value;
    } else {
      return '';
    }
  }

  //this function will toggle the status of allocating/deallocating a task for the session
  myTaskAllocate(task: any) {
    // console.log("task 1", task);
    var status = task.status == 2 ? 1 : 2;
    task.status = status;
    var checked = task.checked == true ? false : true;
    task.checked = checked;
    // console.log("task 2", task);
    // if (task.completed == true) {
    //   task.completed = false;
    // }

    // this.loadSprintTasksSessionList(this.tasks);
    // this.loadSprintUserStorySessionList(this.tasks);
  }

  myTaskreAllocate(task: any) {
    // console.log("task 1", task);
    // var status = task.status == 2 ? 1 : 2;
    task.status = 1;
    // var checked = task.checked == true ? false : true;
    task.checked = false;
    task.completed = false;
    task.history = false;
    // console.log("task 2", task);
    // if (task.completed == true) {
    //   task.completed = false;
    // }
  }

  deleteTaskWithAttribute(entityName: any, attributeName: any) {
    var tasks = [];
    if (entityName !== '') {
      tasks = this.tasks.filter(function (task: any) {
        if (
          task.task_desc.indexOf("'" + entityName + "'") !== -1 &&
          task.task_desc.indexOf(attributeName) !== -1
        ) {
          return task;
        }
      });
    }
    if (tasks.length > 0) {
      for (var i = 0; i < tasks.length; i++) {
        this.deleteTaskWithName(tasks[i].description);
      }
    }
  }

  deleteTaskWithNameModel(name: any) {
    // console.log('name', name);
    var taskFound = this.tasks.findIndex(
      (task: any) => task.task_desc == name && task.completed == false
    );
    if (taskFound > -1) {
      this.modelData.tasks.splice(taskFound, 1);
    }
  }

  //Add a task based on task ID
  addTaskModel(newTaskName: any, taskId: any, taskStatus: any, userID: any) {
    if (userID == '') {
      var newTask: any = {
        task_desc: newTaskName,
        status: taskStatus,
        task_combine_id: '',
        assignedto: '',
        assigneduser: '',
        attribute: '',
        environment: '',
        plan_name: '',
        entity_Id: '',
        taskId: this.uuidv4(),
        entity_desc: '',
        completed: false,
        checked: false,
        history: false,
      };
    } else {
      var newTask: any = {
        task_desc: newTaskName,
        status: taskStatus,
        task_combine_id: '',
        assignedto: userID,
        assigneduser: this.userName,
        attribute: '',
        environment: '',
        plan_name: '',
        entity_Id: '',
        taskId: this.uuidv4(),
        entity_desc: '',
        completed: false,
        checked: false,
        history: false,
      };
    }
    var newTaskIndex = taskId + 1;
    this.tasks.splice(newTaskIndex, 0, newTask);
  }

  addTaskFromScopeModel(
    newTaskName: any,
    taskId: any,
    taskStatus: any,
    userID: any,
    entity: any,
    attribute: any
  ) {
    if (userID == '') {
      var newTask: any = {
        task_desc: newTaskName,
        status: taskStatus,
        task_combine_id: this.uuidv4(),
        assignedto: 'not assigned',
        assigneduser: 'not assigned',
        attribute: attribute.name,
        environment: '',
        plan_name: 'Scope Mapper',
        entity_Id: entity.eID,
        taskId: this.uuidv4(),
        entity_desc: entity.eName,
        completed: false,
        checked: false,
        history: false,
      };
    }
    var newTaskIndex = taskId + 1;
    this.tasks.splice(newTaskIndex, 0, newTask);
  }

  //Delete a task based on task ID /// model function
  deleteTaskModel(taskId: any) {
    if (taskId >= 0) {
      return this.tasks.splice(taskId, 1);
    }
  }

  //////     ///////

  checkTaskStatus(task: any) {
    this.matchedScenario = this.scenarios.find(
      (eut: any) => eut.eID == task.entity_Id
    );
    if (this.matchedScenario) {
      this.matchedRuninfo = this.runinfo.find(
        (run: any) => run.scenID == this.matchedScenario.scenID
      );
      if (this.matchedRuninfo) {
        if (this.matchedRuninfo.status == 'Y') {
          var reTest = 'RT';
          return reTest;
        } else {
          var reTest = 'T';
          return reTest;
        }
      } else {
        var reTest = 'T';
        return reTest;
      }
    }
    var reTest = 'T';
    return reTest;
  }

  loadDashboardElements() {
    this.generateMytasksStatus();
    this.generateEUTStatus();
    this.generateAttriStatus();
    this.generateEvalScenariosByEUT();
    this.generateEvalScenariosByAttribute();
    this.generateOutcomes();
    this.generateOutcomeAttributes();
    this.attributeCount();
    this.functionalandNonFuncCount();
  }

  updateCockpitDataToModel() {
    this.cockpit.functionalScenarioCount = this.functionalScenarioCount;
    this.cockpit.functionalScenarioPostiveCount = this.functionalScenarioPostiveCount;
    this.cockpit.functionalScenarioNegativeCount = this.functionalScenarioNegativeCount;
    this.cockpit.nonFunctionalScenarioCount = this.nonFunctionalScenarioCount;
    this.cockpit.nonFunctionalScenarioPostiveCount = this.nonFunctionalScenarioPostiveCount;
    this.cockpit.nonFunctionalScenarioNegativeCount = this.nonFunctionalScenarioNegativeCount;

    this.cockpit.scenarioTF = this.scenarioTF;
    this.cockpit.scenarioUR = this.scenarioUR;
    this.cockpit.scenarioBF = this.scenarioBF;
    this.cockpit.scenarioXX = this.scenarioXX;
    this.cockpit.readyEUTStatus = this.readyEUTStatus;
    this.cockpit.scenarioTFStatus = this.scenarioTFStatus;
    this.cockpit.scenarioURStatus = this.scenarioURStatus;
    this.cockpit.scenarioBFStatus = this.scenarioBFStatus;
    this.cockpit.scenarioXXStatus = this.scenarioXXStatus;

    this.cockpit.Attributestatus = this.Attributestatus;

    this.cockpit.EUTEvaluationCount = this.EUTEvaluationCount;
    this.cockpit.EUTEvaluationStatus = this.EUTEvaluationStatus;
    this.cockpit.scenarioExecTF = this.scenarioExecTF;
    this.cockpit.scenarioExecUR = this.scenarioExecUR;
    this.cockpit.scenarioExecBF = this.scenarioExecBF;
    this.cockpit.scenarioExecTFStatus = this.scenarioExecTFStatus;
    this.cockpit.scenarioExecBFStatus = this.scenarioExecBFStatus;
    this.cockpit.scenarioExecURStatus = this.scenarioExecURStatus;

    this.cockpit.AttributeEvaluationCount = this.AttributeEvaluationCount;
    this.cockpit.AttributeEvaluationStatus = this.AttributeEvaluationStatus;

    this.cockpit.cleanEUTOutcome = this.cleanEUTOutcome;
    this.cockpit.cleanEUTTFOutcome = this.cleanEUTTFOutcome;
    this.cockpit.cleanEUTBFOutcome = this.cleanEUTBFOutcome;
    this.cockpit.cleanEUTUROutcome = this.cleanEUTUROutcome;
    this.cockpit.EUTCleanStatus = this.EUTCleanStatus;
    this.cockpit.EUTCleanTFStatus = this.EUTCleanTFStatus;
    this.cockpit.EUTCleanBFStatus = this.EUTCleanBFStatus;
    this.cockpit.EUTCleanURStatus = this.EUTCleanURStatus;

    this.cockpit.cleanAttriOutcome = this.cleanAttriOutcome;
    this.cockpit.AttriCleanStatus = this.AttriCleanStatus;
  }

  functionalandNonFuncCount() {
    this.functionalScenarioCount = 0;
    this.functionalScenarioPostiveCount = 0;
    this.functionalScenarioNegativeCount = 0;
    this.nonFunctionalScenarioCount = 0;
    this.nonFunctionalScenarioPostiveCount = 0;
    this.nonFunctionalScenarioNegativeCount = 0;

    for (var i = 0; i < this.scenarios.length; i++) {
      this.matchedEutinfo = this.euts.find(
        (eut: any) => eut.eID == this.scenarios[i].eID
      );
      if (this.matchedEutinfo) {
        if (
          this.scenarios[i].tID == 'Fe' ||
          this.scenarios[i].tID == 'Rb' ||
          this.scenarios[i].tID == 'Fb'
        ) {
          this.functionalScenarioCount++;
          if (this.scenarios[i].cr == '+') {
            this.functionalScenarioPostiveCount++;
          } else {
            this.functionalScenarioNegativeCount++;
          }
        } else {
          this.nonFunctionalScenarioCount++;
          if (this.scenarios[i].cr == '+') {
            this.nonFunctionalScenarioPostiveCount++;
          } else {
            this.nonFunctionalScenarioNegativeCount++;
          }
        }
      }
    }
    this.updateCockpitDataToModel();
  }

  attributeCount() {
    this.detailsAttributeCount = 0;
    for (var i = 0; i < this.attributes.length; i++) {
      // console.log("this.attributes[i].aDetail", this.attributes[i].aDetail);
      if (this.attributes[i].aDetail) {
        this.detailsAttributeCount++;
      }
    }
  }
  generateMytasksStatus() {
    this.myTaskCount = 0;
    this.myTaskTestCount = 0;
    this.myTaskReTestCount = 0;
    this.myTaskPendingCount = 0;
    this.MyTaskPendingstatus = 0;
    this.MyTaskPendingTeststatus = 0;
    this.MyTaskPendingReTeststatus = 0;
    for (var i = 0; i < this.tasks.length; i++) {
      if (this.tasks[i].assignedto == this.userId) {
        this.myTaskCount++;
        if (this.tasks[i].completed == false) {
          this.myTaskPendingCount++;
          for (var j = 0; j < this.tasks.length; j++) {
            if (this.userId == this.tasks[j].assignedto) {
              if (this.tasks[i].task_desc == this.tasks[j].task_desc) {
                if (this.tasks[j].completed == true) {
                  this.myTaskReTestCount++;
                } else {
                  this.myTaskTestCount++;
                }
              }
            }
          }
        }
      }
    }
    if (this.myTaskPendingCount != 0) {
      this.MyTaskPendingstatus =
        Math.round((this.myTaskPendingCount / this.myTaskCount) * 100) + '%';
    }
    if (this.myTaskTestCount != 0) {
      this.MyTaskPendingTeststatus = Math.round(
        (this.myTaskTestCount / this.myTaskPendingCount) * 100
      );
    }
    if (this.myTaskReTestCount != 0) {
      this.MyTaskPendingReTeststatus = Math.round(
        (this.myTaskReTestCount / this.myTaskPendingCount) * 100
      );
    }
  }

  generateEUTStatus() {
    this.readyEUTCount = 0;
    this.notReadyEUTCount = 0;
    this.scenarioTotalTF = 0;
    this.scenarioTF = 0;
    this.scenarioTotalUR = 0;
    this.scenarioUR = 0;
    this.scenarioTotalBF = 0;
    this.scenarioBF = 0;
    this.scenarioTotalXX = 0;
    this.scenarioXX = 0;
    this.readyEUTStatus = 0;
    this.scenarioTFStatus = 0;
    this.scenarioURStatus = 0;
    this.scenarioBFStatus = 0;
    this.scenarioXXStatus = 0;
    for (var i = 0; i < this.euts.length; i++) {
      this.matchedEutinfo = this.scenarios.find(
        (sec: any) => sec.eID == this.euts[i].eID
      );
      // console.log('this.euts[i].eID', this.euts[i]);

      if (this.matchedEutinfo) {
        this.readyEUTCount++;
        // console.log("this.euts[i]", this.euts[i]);
        if (this.euts[i].eType == 'TF') {
          this.scenarioTF++;
        } else if (this.euts[i].eType == 'BF') {
          this.scenarioBF++;
        } else if (this.euts[i].eType == 'UR') {
          this.scenarioUR++;
        } else if (this.euts[i].eType == 'XX') {
          this.scenarioXX++;
        }
      } else {
        this.notReadyEUTCount++;
      }
      if (this.euts[i].eType == 'TF') {
        this.scenarioTotalTF++;
      } else if (this.euts[i].eType == 'BF') {
        this.scenarioTotalBF++;
      } else if (this.euts[i].eType == 'UR') {
        this.scenarioTotalUR++;
      } else if (this.euts[i].eType == 'XX') {
        this.scenarioTotalXX++;
      }
    }
    if (this.readyEUTCount != 0) {
      this.readyEUTStatus = Math.round(
        (this.readyEUTCount / this.euts.length) * 100
      );
    }
    if (this.scenarioTF != 0) {
      this.scenarioTFStatus = Math.round(
        (this.scenarioTF / this.scenarioTotalTF) * 100
      );
    }
    if (this.scenarioUR != 0) {
      this.scenarioURStatus = Math.round(
        (this.scenarioUR / this.scenarioTotalUR) * 100
      );
    }
    if (this.scenarioBF != 0) {
      this.scenarioBFStatus = Math.round(
        (this.scenarioBF / this.scenarioTotalBF) * 100
      );
    }
    if (this.scenarioXX != 0) {
      this.scenarioXXStatus = Math.round(
        (this.scenarioXX / this.scenarioTotalXX) * 100
      );
    }
  }

  generateAttriStatus() {
    this.readyAttributes = [];
    this.scenarioAttriCount = 0;
    this.Attributestatus = 0;
    for (var i = 0; i < this.Config.listOfAttributesUpdated.length; i++) {
      this.matchedEntity = this.scenarios.find(
        (att: any) => att.tID == this.Config.listOfAttributesUpdated[i].symbol
      );
      if (this.matchedEntity) {
        this.readyAttributes.push(this.Config.listOfAttributesUpdated[i]);

        this.scenarioAttriCount++;
      }
    }
    if (this.scenarioAttriCount != 0) {
      this.Attributestatus = Math.round(
        (this.scenarioAttriCount / this.Config.listOfAttributesUpdated.length) * 100
      );
    }
  }
  generateEvalScenariosByEUT() {
    this.EUTEvaluationCount = 0;
    this.EUTEvaluationStatus = 0;
    this.scenarioExecTF = 0;
    this.scenarioExecUR = 0;
    this.scenarioExecBF = 0;
    this.scenarioExecXX = 0;
    this.scenarioExecTFStatus = 0;
    this.scenarioExecBFStatus = 0;
    this.scenarioExecURStatus = 0;
    this.scenarioExecXXStatus = 0;
    this.matchedscenarioTF = 0;
    this.matchedscenarioBF = 0;
    this.matchedscenarioUR = 0;
    this.matchedscenarioXX = 0;
    this.evaluvatedEntities = [];
    for (var m = 0; m < this.euts.length; m++) {
      this.matchedEutinfo = this.scenarios.find(
        (sec: any) => sec.eID == this.euts[m].eID
      );
      if (this.matchedEutinfo) {
        if (this.euts[m].eType == 'TF') {
          this.matchedscenarioTF++;
        } else if (this.euts[m].eType == 'BF') {
          this.matchedscenarioBF++;
        } else if (this.euts[m].eType == 'UR') {
          this.matchedscenarioUR++;
        } else if (this.euts[m].eType == 'XX') {
          this.matchedscenarioXX++;
        }
      }
    }
    for (var i = 0; i < this.euts.length; i++) {
      this.clean2 = false;
      this.breakScenarios = false;
      // for (var j = 0; j < this.tasks.length; j++) {
      //   if (this.euts[i].eID == this.tasks[j].entity_Id) {
      //     if (this.tasks[j].completed == false) {
      //       break;
      //     }
      //   }
      // }
      for (var k = 0; k < this.scenarios.length; k++) {
        if (this.euts[i].eID == this.scenarios[k].eID) {
          if (this.breakScenarios == true) {
            break;
          }
          for (var l = 0; l < this.runinfo.length; l++) {
            if (this.scenarios[k].scenID == this.runinfo[l].scenID) {
              if (this.runinfo[l].status == 'N') {
                this.breakScenarios = true;
                break;
              } else {
                this.clean2 = true;
              }
            }
          }
        }
        if (this.clean2 == true) {
          if (k == this.scenarios.length - 1) {
            this.evaluvatedEntities.push(this.euts[i]);
            this.EUTEvaluationCount++;
            if (this.euts[i].eType == 'TF') {
              this.scenarioExecTF++;
            } else if (this.euts[i].eType == 'BF') {
              this.scenarioExecBF++;
            } else if (this.euts[i].eType == 'UR') {
              this.scenarioExecUR++;
            } else if (this.euts[i].eType == 'XX') {
              this.scenarioExecXX++;
            }
          }
        }
      }
    }
    // console.log("ETF", this.scenarioExecTF);
    // console.log("TF", this.matchedscenarioTF);
    // console.log("EBF", this.scenarioExecBF);
    // console.log("BF", this.matchedscenarioBF);
    // console.log("EUR", this.scenarioExecUR);
    // console.log("UR", this.matchedscenarioUR);
    // console.log("this.evaluvatedEntities",this.evaluvatedEntities);
    if (this.EUTEvaluationCount != 0) {
      this.EUTEvaluationStatus = Math.round(
        (this.EUTEvaluationCount / this.euts.length) * 100
      );
    }
    if (this.scenarioExecTF != 0) {
      this.scenarioExecTFStatus = Math.round(
        (this.scenarioExecTF / this.scenarioTotalTF) * 100
      );
    }
    if (this.scenarioExecBF != 0) {
      this.scenarioExecBFStatus = Math.round(
        (this.scenarioExecBF / this.scenarioTotalBF) * 100
      );
    }
    if (this.scenarioExecUR != 0) {
      this.scenarioExecURStatus = Math.round(
        (this.scenarioExecUR / this.scenarioTotalUR) * 100
      );
    }
    if (this.scenarioExecXX != 0) {
      this.scenarioExecXXStatus = Math.round(
        (this.scenarioExecXX / this.scenarioTotalXX) * 100
      );
    }
  }

  generateEvalScenariosByAttribute() {
    this.AttributeEvaluationCount = 0;
    this.AttributeEvaluationStatus = 0;
    this.evaluvatedAttributes = [];
    for (var i = 0; i < this.readyAttributes.length; i++) {
      this.clean3 = false;
      this.breakScenarios = false;
      // for (var j = 0; j < this.tasks.length; j++) {
      //   if (this.readyAttributes[i].name == this.tasks[j].attribute) {
      //     if (this.tasks[j].completed == false) {
      //       break;
      //     }
      //   }
      // }
      for (var k = 0; k < this.scenarios.length; k++) {
        if (this.readyAttributes[i].symbol == this.scenarios[k].tID) {
          if (this.breakScenarios == true) {
            break;
          }
          for (var l = 0; l < this.runinfo.length; l++) {
            if (this.scenarios[k].scenID == this.runinfo[l].scenID) {
              if (this.runinfo[l].status == 'N') {
                this.breakScenarios = true;
                break;
              } else {
                this.clean3 = true;
              }
            }
          }
        }
        if (this.clean3 == true) {
          if (k == this.scenarios.length - 1) {
            this.evaluvatedAttributes.push(this.readyAttributes[i]);
            this.AttributeEvaluationCount++;
          }
        }
      }
    }
    // console.log("1", this.scenarioAttriCount);
    // console.log("2", this.AttributeEvaluationCount);
    // console.log("this.evaluvatedAttributes",this.evaluvatedAttributes);
    if (this.AttributeEvaluationCount != 0) {
      this.AttributeEvaluationStatus = Math.round(
        (this.AttributeEvaluationCount / this.Config.listOfAttributesUpdated.length) * 100
      );
    }
  }
  generateOutcomes() {
    this.cleanEUTOutcome = 0;
    this.cleanEUTTFOutcome = 0;
    this.cleanEUTBFOutcome = 0;
    this.cleanEUTUROutcome = 0;
    this.cleanEUTXXOutcome = 0;
    this.cleanEUTTFTotalOutcome = 0;
    this.cleanEUTBFTotalOutcome = 0;
    this.cleanEUTURTotalOutcome = 0;
    this.cleanEUTXXTotalOutcome = 0;
    this.EUTCleanStatus = 0;
    this.EUTCleanTFStatus = 0;
    this.EUTCleanBFStatus = 0;
    this.EUTCleanURStatus = 0;
    this.EUTCleanXXStatus = 0;
    this.cleanEntities = [];
    for (var i = 0; i < this.evaluvatedEntities.length; i++) {
      this.clean1 = false;
      this.breakScenariosloop = false;
      for (var j = 0; j < this.scenarios.length; j++) {
        if (this.evaluvatedEntities[i].eID == this.scenarios[j].eID) {
          var matchedInfos = [];
          for (var k = 0; k < this.runinfo.length; k++) {
            if (this.scenarios[j].scenID == this.runinfo[k].scenID) {
              matchedInfos.push(this.runinfo[k]);
              this.runInfo = true;
            }
            if (k == this.runinfo.length - 1) {
              if (this.runInfo == true) {
                var latestDate = matchedInfos.sort(
                  this.getLatestDate('timeStamp', 'desc')
                );
                // console.log("latestDate", latestDate);
                // console.log("latestDate1", latestDate[0]);
                if (latestDate.length > 0) {
                  if (latestDate[0].outcome == 'F') {
                    this.breakScenariosloop = true;
                    break;
                  } else {
                    this.clean1 = true;
                  }
                }
              }
            }
          }
          if (this.breakScenariosloop == true) {
            break;
          }
        }
        // if (this.clean1 == true) {
        if (j == this.scenarios.length - 1) {
          if (this.clean1 == true) {
            this.cleanEntities.push(this.evaluvatedEntities[i]);
            // console.log("EUT",this.evaluvatedEntities[i]);
            this.cleanEUTOutcome++;
            if (this.evaluvatedEntities[i].eType == 'TF') {
              this.cleanEUTTFOutcome++;
            } else if (this.evaluvatedEntities[i].eType == 'BF') {
              this.cleanEUTBFOutcome++;
            } else if (this.evaluvatedEntities[i].eType == 'UR') {
              this.cleanEUTUROutcome++;
            } else if (this.evaluvatedEntities[i].eType == 'XX') {
              this.cleanEUTXXOutcome++;
            }
          }
        }
        // }
      }

      if (this.evaluvatedEntities[i].eType == 'TF') {
        this.cleanEUTTFTotalOutcome++;
      } else if (this.evaluvatedEntities[i].eType == 'BF') {
        this.cleanEUTBFTotalOutcome++;
      } else if (this.evaluvatedEntities[i].eType == 'UR') {
        this.cleanEUTURTotalOutcome++;
      } else if (this.evaluvatedEntities[i].eType == 'XX') {
        this.cleanEUTXXTotalOutcome++;
      }
    }

    if (this.cleanEUTOutcome != 0) {
      this.EUTCleanStatus = Math.round(
        (this.cleanEUTOutcome / this.euts.length) * 100
      );
    }
    if (this.cleanEUTTFOutcome != 0) {
      this.EUTCleanTFStatus = Math.round(
        (this.cleanEUTTFOutcome / this.scenarioTotalTF) * 100
      );
    }
    if (this.cleanEUTBFOutcome != 0) {
      this.EUTCleanBFStatus = Math.round(
        (this.cleanEUTBFOutcome / this.scenarioTotalBF) * 100
      );
    }
    if (this.cleanEUTUROutcome != 0) {
      this.EUTCleanURStatus = Math.round(
        (this.cleanEUTUROutcome / this.scenarioTotalUR) * 100
      );
    }
    if (this.cleanEUTXXOutcome != 0) {
      this.EUTCleanXXStatus = Math.round(
        (this.cleanEUTXXOutcome / this.scenarioTotalXX) * 100
      );
    }
  }

  generateOutcomeAttributes() {
    this.cleanAttriOutcome = 0;
    this.AttriCleanStatus = 0;
    for (var i = 0; i < this.evaluvatedAttributes.length; i++) {
      this.clean4 = false;
      this.runInfo = false;
      for (var j = 0; j < this.scenarios.length; j++) {
        if (this.evaluvatedAttributes[i].symbol == this.scenarios[j].tID) {
          var matchedInfos: any = [];
          for (var k = 0; k < this.runinfo.length; k++) {
            if (this.scenarios[j].scenID == this.runinfo[k].scenID) {
              matchedInfos.push(this.runinfo[k]);
              this.runInfo = true;
            }
          }
        }

        if (this.runInfo == true) {
          var latestDate = matchedInfos.sort(
            this.getLatestDate('timeStamp', 'desc')
          );
          // console.log("latestDate", latestDate);
          // console.log("latestDate1", latestDate[0]);
          if (latestDate[0]) {
            if (latestDate[0].outcome == 'F') {
              break;
            } else {
              this.clean4 = true;
            }
          }
        }
        if (this.clean4 == true) {
          if (j == this.scenarios.length - 1) {
            this.cleanAttributes.push(this.evaluvatedAttributes[i]);
            this.cleanAttriOutcome++;
          }
        }
      }
    }
    // console.log("cleanAttriOutcome",this.cleanAttriOutcome);
    if (this.cleanAttriOutcome != 0) {
      this.AttriCleanStatus = Math.round(
        (this.cleanAttriOutcome / this.Config.listOfAttributesUpdated.length) * 100
      );
    }
    this.getAllDetails();
  }
  getLatestDate(key: any, order = 'asc') {
    return function innerSort(a: any, b: any) {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        // property doesn't exist on either object
        return 0;
      }

      const varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
      const varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];

      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return order === 'desc' ? comparison * -1 : comparison;
    };
  }

  getAllDetails() {
    var finalObj = {
      evaluvatedAttributes: this.evaluvatedAttributes,
      evaluvatedEntities: this.evaluvatedEntities,
      cleanAttributes: this.cleanAttributes,
      cleanEntities: this.cleanEntities,
    };
    this._sharedService.addAlldetails(finalObj);
    // console.log("this.finalObj",finalObj);
    window.localStorage.setItem('allDetails', JSON.stringify(finalObj));
  }

  //Makes a call to model to add task
  //checks if the tasks belong to current session

  addTaskFromScope(
    newTaskName: any,
    taskId: any,
    taskStatus: any,
    userID: any,
    entity: any,
    attribute: any
  ) {
    var taskExist = this.modelData.tasks.find(
      (task: any) => task.task_desc == newTaskName && task.completed == false
    );
    if (taskExist == undefined) {
      if (this.modelData.tasks.length > 0 && taskStatus == 0) {
        for (var i = 0; i < this.modelData.tasks.length; i++) {
          if (!(this.modelData.tasks[taskId].task_desc === '')) {
            this.addTaskFromScopeModel(
              newTaskName,
              taskId,
              taskStatus,
              userID,
              entity,
              attribute
            );
            return true;
          } else {
            if (
              this.modelData.tasks[taskId].task_desc === '' &&
              !(taskId === this.modelData.tasks.length - 1)
            ) {
              this.deleteTaskModel(taskId);
              this.loadMytasksList(this.tasks);
            }
            return false;
          }
        }
        return; /// added extra
      } else {
        this.addTaskFromScopeModel(
          newTaskName,
          taskId,
          taskStatus,
          userID,
          entity,
          attribute
        );
        return true;
      }
    } else {
      return;
    }
  }

  addTask(newTaskName: any, taskId: any, taskStatus: any, userID: any) {
    var taskExist = this.modelData.tasks.find(
      (task: any) => task.task_desc == newTaskName && task.completed == false
    );
    if (taskExist == undefined) {
      if (this.modelData.tasks.length > 0 && taskStatus == 0) {
        for (var i = 0; i < this.modelData.tasks.length; i++) {
          if (!(this.modelData.tasks[taskId].task_desc == '')) {
            this.addTaskModel(newTaskName, taskId, taskStatus, userID);
            this.loadMytasksList(this.tasks);
            return true;
          } else {
            if (
              this.modelData.tasks[taskId].task_desc == '' &&
              !(taskId === this.modelData.tasks.length - 1)
            ) {
              this.deleteTaskModel(taskId);
              this.loadMytasksList(this.tasks);
            }
            return false;
          }
        }
        return; /// added extra
      } else {
        // this.model.addTask(newTaskName, taskId, taskStatus, userID);
        this.loadMytasksList(this.tasks);
        return true;
      }
    } else {
      return; /// added extra
    }
  }

  //Makes a call to model to delete task
  deleteTask(taskId: any) {
    this.deleteTaskModel(taskId);
    this.loadMytasksList(this.tasks);
  }
  //Function to clear th empty list
  onFocusOut(model: any, id: any) {
    if (!model) {
      this.deleteTask(id);
    }
  }
  deleteTaskWithName(taskName: any) {
    this.deleteTaskWithNameModel(taskName);
  }

  deleteTaskWithEntity(entityName: any) {
    // console.log("entityName", entityName);
    var tasks = [];
    if (entityName !== '') {

      tasks = this.modelData.tasks.filter((task: any) => {
        if (task.task_desc.indexOf(entityName) !== -1) {
          return task;
        }
      });
    }
    // console.log("tasks", tasks);
    if (tasks.length > 0) {
      for (var i = 0; i < tasks.length; i++) {
        this.deleteTaskWithNameModel(tasks[i].task_desc);
      }
    }
  }

  updateTask(newTask: any, oldTask: any) {
    // console.log("newTask", newTask);
    // console.log("oldTask", oldTask);
    var tasks = [];
    if (oldTask !== '') {
      tasks = this.modelData.tasks.filter((task: any) => {
        if (task.task_desc.indexOf(oldTask) !== -1) {
          return task;
        }
      });
    }
    if (tasks.length > 0) {
      for (var i = 0; i < tasks.length; i++) {
        tasks[i].task_desc = tasks[i].task_desc.replace(oldTask, newTask);
      }
    }
  }

  //this function will toggle the status of allocating/deallocating a task for the session
  allocateTask(task: any) {
    var status = task.status == 2 ? 0 : 2;
    task.status = status;
  }

  //function to count the number of tasks allocated for the session
  countSessionTask() {
    var sessionTasks = this.modelData.tataskssks.filter(
      (task: any) => task.status == 'allocated'
    );
    var length = sessionTasks.length;
    return length;
  }

  //function to count the number of tasks Completed for the session
  countCompletedTask() {
    var completedTasks = this.modelData.tasks.filter(
      (task: any) => task.completed == true
    );
    var length = completedTasks.length;
    return length;
  }
  //function to count the number of tasks which arent completed in the task list
  counttasks() {
    var notCompletedTasks = this.modelData.tasks.filter(
      (task: any) => !task.completed
    );
    var length = notCompletedTasks.length;
    return length;
  }

  //navigate to sprint planner on click sprint tab
  navigateSprint() {
    var sprint = { "toolType": 'sp1' };
    this.openTool(sprint);
  }

  openTool(taskName: any) {
    // console.log('taskName', taskName);
    //   // new code open
    //   this.currentTask = "";
    if (taskName.toolType) {

      if (taskName.toolType == 'pm') {
        this.mainComponent.openTool('personaMapperMindMap');
        this.router.navigateByUrl('/main/personaMapperMindMap');
        // this.views['Pm'].active = true;
      } else if (taskName.toolType == 'im') {
        this.mainComponent.openTool('interactionMapperMindMap');
        this.router.navigateByUrl('/main/interactionMapperMindMap');
        // this.views['Im'].active = true;
      } else if (taskName.toolType == 'sc') {
        this.mainComponent.openTool('scopeMapperMindMap');
        this.router.navigateByUrl('/main/scopeMapperMindMap');
        // this.views['Sc'].active = true;
      } else if (taskName.toolType == 'cl') {
        this.mainComponent.openTool('checklist');
        this.router.navigateByUrl('/main/checklist');
        // this.views['Cl'].active = true;
      } else if (taskName.toolType == 'dd') {
        this.mainComponent.openTool('deepDive');
        this.router.navigateByUrl('/main/deepDive');
        // this.views['Dd'].active = true;
      } else if (taskName.toolType == 'de') {
        this.mainComponent.openTool('testDesigner');
        this.router.navigateByUrl('/main/testDesigner');
        // this.views['Td'].active = true;
      } else if (taskName.toolType == 'tm') {
        this.mainComponent.openTool('testManager');
        this.router.navigateByUrl('/main/testManager');
        // this.views['Tm'].active = true;
      } else if (taskName.toolType == 'ex') {
        this.mainComponent.openTool('testExecutor');
        this.router.navigateByUrl('/main/testExecutor');
        // this.views['Ex'].active = true;
      } else if (taskName.toolType == 'sp') {
        this.mainComponent.openTool('sprintPlanner');
        // this.router.navigateByUrl('/main/sprintPlanner/'+step);
        // this.views['Ex'].active = true;
      } else if (taskName.toolType == 'sp1') {
        this.mainComponent.openTool('sprintPlannerPlus');
        // this.router.navigateByUrl('/main/sprintPlanner/'+step);
        // this.views['Ex'].active = true;
      } else if (taskName.toolType == 'ft') {
        // this.views['Ex'].active = true;
      }
    }
    //   // new code close
    setTimeout(() => { this.setArguementsForTool(taskName); }, 500);

  }

  openTaskTool(taskName: any) {
    if (taskName.toolType) {

      if (taskName.toolType == 'pm') {
        this.mainComponent.openTool('personaMapperEntityMindMap');
        this.router.navigateByUrl('/main/personaMapperEntityMindMap');
        // this.views['Pm'].active = true;
      } else if (taskName.toolType == 'im') {
        this.mainComponent.openTool('interactionMapperMindMap');
        this.router.navigateByUrl('/main/interactionMapperMindMap');
        // this.views['Im'].active = true;
      } else if (taskName.toolType == 'sc') {
        this.mainComponent.openTool('scopeMapperEntityMindMap');
        this.router.navigateByUrl('/main/scopeMapperEntityMindMap');
        // this.views['Sc'].active = true;
      } else if (taskName.toolType == 'cl') {
        this.mainComponent.openTool('checklist');
        this.router.navigateByUrl('/main/checklist');
        // this.views['Cl'].active = true;
      } else if (taskName.toolType == 'dd') {
        this.mainComponent.openTool('deepDive');
        this.router.navigateByUrl('/main/deepDive');
        // this.views['Dd'].active = true;
      } else if (taskName.toolType == 'de') {
        this.mainComponent.openTool('testDesigner');
        this.router.navigateByUrl('/main/testDesigner');
        // this.views['Td'].active = true;
      } else if (taskName.toolType == 'tm') {
        this.mainComponent.openTool('testManager');
        this.router.navigateByUrl('/main/testManager');
        // this.views['Tm'].active = true;
      } else if (taskName.toolType == 'ex') {
        this.mainComponent.openTool('testExecutor');
        this.router.navigateByUrl('/main/testExecutor');
        // this.views['Ex'].active = true;
      } else if (taskName.toolType == 'sp') {
        this.mainComponent.openTool('sprintPlanner');
        // this.router.navigateByUrl('/main/sprintPlanner/'+step);
        // this.views['Ex'].active = true;
      } else if (taskName.toolType == 'sp1') {
        this.mainComponent.openTool('sprintPlannerPlus');
        // this.router.navigateByUrl('/main/sprintPlanner/'+step);
        // this.views['Ex'].active = true;
      } else if (taskName.toolType == 'ft') {
        // this.views['Ex'].active = true;
      }
    }
    setTimeout(() => { this.setArguementsForTool(taskName); }, 500);
  }
  generateFullStatusDetails(parameter: any) {
    localStorage.setItem('cockpitName', parameter);
  }
  invoke(appName: any, appParams: any) {
    // this.am.invoke(appName, appParams); // comentted temply
    this.generateReport();
  }
  generateReport() { }
  setArguementsForTool(taskDetails: any) {
    var envName = '';
    var testTypes = [
      {
        name: 'Feature Behaviour',
        symbol: 'Fe',
        eType: 'TF',
      },
      {
        name: 'Requirement Behaviour',
        symbol: 'Rb',
        eType: 'UR',
      },
      {
        name: 'Flow Behaviour',
        symbol: 'Fb',
        eType: 'BF',
      },
    ];
    // new code open
    console.log('taskDetails Sprint', taskDetails);

    var entity = this.modelData.listOfEUTs.find(
      (entity: any) => entity.eID == taskDetails.entity_Id
    );
    if (taskDetails.attribute) {
      var testType: any = this.Config.listOfAttributesUpdated.find(
        (attribute) => attribute.name == taskDetails.attribute.name
      );
      if (!testType) {
        testType = testTypes.find(
          (attribute) => attribute.name == taskDetails.attribute.name
        );
      }
    }
    envName = taskDetails.environment;
    if (taskDetails.toolType == 'cl') {
      window.localStorage.setItem(
        'checklistDetails',
        JSON.stringify(taskDetails.checklistDetails)
      );


      taskDetails.checklistDetails['toolType'] = taskDetails.toolType;
      this._sharedService.triggerTool(taskDetails.checklistDetails);
      let checklistArray = ['Checklist'];
      window.localStorage.setItem('exportedData', JSON.stringify(checklistArray));
      window.open('/exportReport', '_blank');
      window.localStorage.setItem("autoDownload", 'true');
      // this.checklistComponent.generateReport();
    } else if (taskDetails.toolType == 'pm') {
      // this.interactionMapperMindMapComponent.ngOnInit();
      // this.deepDiveComponent.selectedEUT = taskDetails.entityType;
      // this.PersonaMapperEntityMindMapComponent.activate(entity);
      entity['toolType'] = taskDetails.toolType;
      this._sharedService.triggerTool(entity);
    } else if (taskDetails.toolType == 'im') {
      // this.interactionMapperMindMapComponent.ngOnInit();
      // this.deepDiveComponent.selectedEUT = taskDetails.entityType;
      // this.interactionMapperMindMapComponent.activate(entity);
      entity['toolType'] = taskDetails.toolType;
      this._sharedService.triggerTool(entity);
    } else if (taskDetails.toolType == 'sc') {

      entity['toolType'] = taskDetails.toolType;
      this._sharedService.triggerTool(entity);
    } else if (taskDetails.toolType == 'dd') {
      this.deepDiveComponent.ngOnInit();
      // this.deepDiveComponent.selectedEUT = taskDetails.entityType;
      // this.deepDiveComponent.activate(entity);
      entity['toolType'] = taskDetails.toolType;
      this._sharedService.triggerTool(entity);
    } else if (taskDetails.toolType == 'de') {
      // this.testDesignerComponent.ngOnInit();
      // this.testDesignerComponent.selectedEUT = taskDetails.entityType;
      // this.testDesignerComponent.activate(entity);
      entity['toolType'] = taskDetails.toolType;
      entity['testType'] = testType;
      this._sharedService.triggerTool(entity);
    } else if (taskDetails.toolType == 'tm') {
      // this.mainComponent.goToView();
      let suitesArray = ['Suites'];
      window.localStorage.setItem('exportedData', JSON.stringify(suitesArray));
      window.localStorage.setItem(
        'selectedSuite',
        taskDetails.suiteDetails.suiteName
      );
      window.open('/exportReport', '_blank');
      window.localStorage.setItem("autoDownload", 'true');
    } else if (taskDetails.toolType == 'ex') {
      // console.log("entity",entity);
      // console.log("testType",testType);
      // console.log("envName",envName);
      this.testExecutorComponent.ngOnInit();
      // this.testExecutorComponent.selectedEUT = taskDetails.entityType;
      // this.testExecutorComponent.activate(entity, testType, envName);
      entity['toolType'] = taskDetails.toolType;
      entity['testType'] = testType;
      entity['envName'] = envName;
      this._sharedService.triggerTool(entity);
    }
    // new code close
  }
  getHistoryArray() {
    this.sessionHistoryArray = this.mainComponent.sessionHistoryArray;
  }

  getProjectTaskListByEUT(id: any, entity: any, newtagId: any) {
    this.mainComponent.activateLoader(true);
    if (this.lastActiveProjectAccordId != '') {
      $('#' + this.lastActiveProjectAccordId + '').click();
      this.setToggleIcon(this.lastActiveProjectAccordId, false, 'EUT');
    }
    this.setToggleIcon(newtagId, true, 'EUT');
    this.lastActiveProjectAccordId = newtagId;
    this.listForProjectTasks = '';
    var loaderHtml = '';
    // loaderHtml += '<div class="loader-container" >'
    // loaderHtml += '<div class="spinner-border text-primary" role="status">'
    loaderHtml += '<span class="visually-hidden" ><fa-icon class="fa fa-spin icon-white" [icon]="faSpinner"></fa-icon> Loading tasks...</span>'
    // loaderHtml += loaderHtml += '</div>'
    // loaderHtml += '</div>'
    // console.log("loaderHtml",loaderHtml);
    this.listForProjectTasks = loaderHtml;
    var html: any = '<ul>';
    for (var i = 0; i < this.modelData.tasks.length; i++) {
      var task = this.modelData.tasks[i];
      if (task.entity_Id == entity.entity_Id && task.activity.type != 'RI') {
        if (task.assignedto == '' && (task.status != 2 || task.status != 1)) {
          html += '<li>' + this.modelData.tasks[i].task_desc + '</li>'
        }
      }
      if (task.activity.type == 'RI' && task.primaryentity_Id == entity.entity_Id) {
        if (task.assignedto == '' && (task.status != 2 || task.status != 1)) {
          html += '<li>' + this.modelData.tasks[i].task_desc + '</li>'
        }
      }
    }
    html += '</ul>'
    this.listForProjectTasks = html;
    this.mainComponent.activateLoader(false);
  }

  getMyTaskListByEUT(id: any, entity: any, newtagId: any) {
    this.mainComponent.activateLoader(true);
    if (this.lastActiveMyTasksAccordId != '') {
      $('#' + this.lastActiveMyTasksAccordId + '').click();
      // this.setToggleIconMytasks(this.lastActiveMyTasksAccordId, false, 'EUT');
    }
    // this.setToggleIconMytasks(newtagId, true, 'EUT');
    this.lastActiveMyTasksAccordId = newtagId;
    var html: any = '<ul>';
    for (var i = 0; i < this.modelData.tasks.length; i++) {
      var task = this.modelData.tasks[i];
      if (task.assignedto == this.userId && (entity.entity_Id == task.primaryentity_Id || task.entity_Id == entity.entity_Id) && (task.status == 2 || task.status == 1) && (task.activity.type != 'RI')) {
        html += '<li (click)="openTool(task)"> <fa-icon [icon]="faCircle" class="far icon form-control strict transparent planner-icon icon-white mapperReadOnly height10px"></fa-icon>';

        // html += '<fa-icon [icon]="faCircle" class="far icon form-control strict transparent planner-icon icon-white mapperReadOnly height10px"></fa-icon>&nbsp;';
        // html += "<fa-icon [icon]='faArrowAltCircleRight'  class='far icon form-control strict transparent planner-icon icon-white mapperReadOnly height10px'></fa-icon>";
        html += this.modelData.tasks[i].task_desc + '</li>'
      }
      if (task.activity.type == 'RI' && task.primaryentity_Id == entity.entity_Id && (task.status == 2 || task.status == 1)) {
        html += '<li>' + this.modelData.tasks[i].task_desc + '</li>'
      }
    }
    html += '</ul>'
    this.listForMyTasks = html;
    this.mainComponent.activateLoader(false);
  }
}
